import axios from 'axios'
import store from './store'

export const setupInterceptor = () => {
  axios.interceptors.request.use(
    config => {
      const token = store.getters['auth/token']
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    function(err) {
      return Promise.reject(err)
    }
  )
  axios.interceptors.response.use(
    i => i,
    err => {
      store.commit('error/addError', err)
      return Promise.reject(err)
    }
  )
}
